import { render, staticRenderFns } from "./editWhiteboard.vue?vue&type=template&id=2a4b21b5&scoped=true"
import script from "./editWhiteboard.vue?vue&type=script&lang=js"
export * from "./editWhiteboard.vue?vue&type=script&lang=js"
import style0 from "./editWhiteboard.vue?vue&type=style&index=0&id=2a4b21b5&prod&scoped=true&lang=css"
import style1 from "./editWhiteboard.vue?vue&type=style&index=1&id=2a4b21b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b21b5",
  null
  
)

export default component.exports